import { auditApi as api } from '../../api';

export const createSingleAudit = async (data) => {
  try {
      const token = sessionStorage.getItem('token');
      const response = await api.post('/add-single-audit', data, {
          headers: {
              'Authorization': `Bearer ${token}`
          }
      });
      return response.data
  } catch (error) {
      throw error.response ? error.response.data.error : error.message;
  }
}


export const getAudit = async (client_id) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.get('/get-all-audits', {
          params:{
            client_id:client_id
          },
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}
export const get_client_unit_base_vendor = async (client_id) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.get(`/get_client_unit_base_vendor`,
     {
      params:{
        client_id:client_id
      },
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};
export const get_client_wise_audit = async (client_id) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.get(`/get-audit`,
     {
      params:{
        client_id:client_id
      },
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};
export const getAuditDetails = async (id) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.get(`/audit_details/${id}`,
     {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};
export const updateAudit = async (status,Data) => {
    try {
        const token = sessionStorage.getItem('token');
        const formData = new FormData();
        const auditDetails = Data.data.map(item => ({
            id: item.id,
            auditors_remark: item.auditors_remark,
            status: item.status,
            ...(typeof item.attachment === "string" ? { attachment: item.attachment } : {})
        }));
        formData.append("data", JSON.stringify({ auditDetails }));
        formData.append("status", status);
        Data.data.forEach(item => {
            if (item.attachment instanceof File) {
                formData.append(item.id, item.attachment);
            }
        });
        const response = await api.put(`/audit_details`, formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'
            }
        });
 
        return response.data;



        
    } catch (error) {
        console.error("❌ Error updating vendor audit:", error);
        throw error.response ? error.response.data.error : error.message;
    }
};
export const extendAudit = async(id,data)=>{
  try {
    const token = sessionStorage.getItem('token');
     const response = await api.put(`/update-audit/${id}`,data,{
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }

};
export const getlatestAudit = async (client_id) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.get('/fetch-year-wise-audit', {
          params:{
            client_id:client_id
          },
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}
export const filteredAudit = async (client_id,fromMonth,toMonth) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.get('/get-filter-wise-audit-all-records', {
          params:{
            client_id:client_id,
            from_date : fromMonth,
            to_date: toMonth
          },
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}
export const filteredAuditDetails = async (client_id,fromMonth,toMonth) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.get('/get-filter-wise-audit', {
          params:{
            client_id:client_id,
            from_date : fromMonth,
            to_date: toMonth
          },
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}

export const latestAuditDetailsData = async (client_id) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.get(`/get-year-wise`,
     {
      params:{
        client_id:client_id
      },
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};
// export const downloadAuditDetails = async (data) => {
//   try {
//       const token = sessionStorage.getItem('token');
//       const response = await api.post(`/download_selected_audit_records`, data, {
//           responseType: 'blob',
//           headers: {
//               'Authorization': `Bearer ${token}`
//           }
//       });

//       if (response.status === 200 && response.data) {
//           const url = window.URL.createObjectURL(new Blob([response.data]));
//           const link = document.createElement('a');
//           link.href = url;
//           link.setAttribute('download', `${data.titleName}.xlsx`);
//           document.body.appendChild(link);
//           link.click();
//           link.remove();
//           return { success: true };  // Return success flag to indicate download success
//       } else {
//           throw new Error("Invalid file response");
//       }
//   } catch (error) {
//       console.log(error);
//       throw error.response ? error.response.data.message : error.message;
//   }
// }

export const downloadAuditDetails = async (data) => {
  try {
    const token = sessionStorage.getItem("token");

    const response = await api.post(
      `/download_selected_audit_records`,
      data,
      {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.status === 200 && response.data) {
      const url = window.URL.createObjectURL(new Blob([response.data]));

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${data.titleName}.xlsx`);

      document.body.appendChild(link);
      link.click();
      link.remove();

      return { success: true };
    } else {
      throw new Error("Invalid file response");
    }

  } catch (error) {
    if (
      error.response &&
      error.response.data instanceof Blob
    ) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
          try {
            const text = reader.result;
            const json = JSON.parse(text);

            reject(json.error || "Download failed");
          } catch (e) {
            reject("Download failed");
          }
        };

        reader.readAsText(error.response.data);
      });
    }

    // ✅ Normal error
    throw error.response?.data?.message || error.message;
  }
};

export const get_audit_report = async (data) => {
  const reportData = {
    client_id:data.client_id,
    audit_id:data.audit_id,
    start_period:data.start_period,
    end_period:data.end_period,
    unit_id:data.unit_id,
    vendor_id:data.vendor_id,
    report_name:data.report_name

  }
  try {
      const token = sessionStorage.getItem('token');
      const response = await api.post('/get_vendor_wise_reports', reportData,{
          headers: {
              'Authorization': `Bearer ${token}`
          }
      });
      return response.data
  } catch (error) {
      throw error.response ? error.response.data.error : error.message;
  }
}

export const download_all_selected_report = async (data) => {
  try {
      const token = sessionStorage.getItem('token');
      const response = await api.post(`/download_selected_audit_report`, data, {
          responseType: 'blob',
          headers: {
              'Authorization': `Bearer ${token}`
          }
      });

      const contentType = response.headers['content-type'] || '';
      if (contentType.includes('application/json')) {
          const text = await response.data.text();
          const errorData = JSON.parse(text);
          throw errorData.error || errorData.message || 'Download failed';
      }

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${data.report_name}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      return { success: true };
  } catch (error) {
      if (typeof error === 'string') {
          throw error;
      }
      const errData = error.response?.data;
      if (errData instanceof Blob) {
          try {
              const text = await errData.text();
              const parsed = JSON.parse(text);
              throw parsed.error || parsed.message || 'Download failed';
          } catch (parseErr) {
              if (typeof parseErr === 'string') throw parseErr;
              throw error.message || 'Download failed';
          }
      }
      throw errData?.error || errData?.message || error.message || 'Download failed';
  }
}

export const auditReportFilterHeader = async (client_id,fromMonth,toMonth) => {
  const data = {
    client_id:client_id,
    from_date : fromMonth,
    to_date: toMonth
  };
  try {
      const token = sessionStorage.getItem('token');
      const response = await api.post('/get-report-all-filters',data, {        
        headers: {
            'Authorization': `Bearer ${token}`
        }
      });
      return response.data
  } catch (error) {
      throw error.response ? error.response.data.error : error.message;
  }
}